module.exports = __webpack_public_path__ + "static/media/0122_Medium.ab0a78dc.jpg";